import {mainModule} from "../../app";

function MissingTranslationHandler() {
    return function (translationId) {
        return translationId;
    };
}

mainModule.factory('MissingTranslationHandler', MissingTranslationHandler);
